import { Clock, Download } from "lucide-react"
import { Button } from "../ui/button"
import { Card } from "../ui/card"
import { Badge } from "../ui/badge"

export function HistoryTab() {
  return (
    <Card className="p-5 bg-white shadow-md">
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-base font-semibold flex items-center">
          <Clock className="h-4 w-4 mr-2 text-[#FF5533]" />
          Application History
        </h3>
        <Button variant="outline" size="sm">
          <Download className="h-4 w-4 mr-1" />
          Export History
        </Button>
      </div>

      <div className="relative border-l-2 border-gray-200 ml-3 pl-6 space-y-6">
        <div className="relative">
          <div className="absolute -left-9 top-0 w-5 h-5 rounded-full bg-[#FF5533]"></div>
          <div>
            <div className="flex justify-between items-start">
              <div>
                <h4 className=" font-medium">Information Requested</h4>
                <p className="text-sm text-gray-500">April 14, 2025 at 11:15 AM</p>
              </div>
              <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">
                Information Request
              </Badge>
            </div>
            <p className=" text-gray-700 mt-2">
              Sarah Johnson requested additional safety documentation from the agent.
            </p>
          </div>
        </div>

        <div className="relative">
          <div className="absolute -left-9 top-0 w-5 h-5 rounded-full bg-blue-500"></div>
          <div>
            <div className="flex justify-between items-start">
              <div>
                <h4 className=" font-medium">Initial Review Started</h4>
                <p className="text-sm text-gray-500">April 13, 2025 at 10:30 AM</p>
              </div>
              <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200">
                Review
              </Badge>
            </div>
            <p className=" text-gray-700 mt-2">John Smith started the initial review of the application.</p>
          </div>
        </div>

        <div className="relative">
          <div className="absolute -left-9 top-0 w-5 h-5 rounded-full bg-green-500"></div>
          <div>
            <div className="flex justify-between items-start">
              <div>
                <h4 className=" font-medium">Application Assigned</h4>
                <p className="text-sm text-gray-500">April 12, 2025 at 2:15 PM</p>
              </div>
              <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
                Assignment
              </Badge>
            </div>
            <p className=" text-gray-700 mt-2">Application assigned to John Smith by Maria Rodriguez.</p>
          </div>
        </div>

        <div className="relative">
          <div className="absolute -left-9 top-0 w-5 h-5 rounded-full bg-gray-400"></div>
          <div>
            <div className="flex justify-between items-start">
              <div>
                <h4 className=" font-medium">Application Received</h4>
                <p className="text-sm text-gray-500">April 12, 2025 at 9:45 AM</p>
              </div>
              <Badge variant="outline" className="bg-gray-100 text-gray-700 border-gray-200">
                System
              </Badge>
            </div>
            <p className=" text-gray-700 mt-2">Application #A-12345 for Rubber Mill, Inc. has been received.</p>
          </div>
        </div>
      </div>
    </Card>
  )
}
